import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoCall } from 'react-icons/io5';
import { Offcanvas } from 'bootstrap';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();

  useEffect(() => {
    // Ensure offcanvas is hidden and backdrop removed on route change
    const cleanupOffcanvas = () => {
      const offcanvasEl = document.getElementById('offcanvasNavbar');
      if (offcanvasEl) {
        let offcanvas = Offcanvas.getInstance(offcanvasEl);
        if (!offcanvas) {
          offcanvas = new Offcanvas(offcanvasEl);
        }
        offcanvas.hide();
      }

      // Delay to let Bootstrap finish hide animation
      setTimeout(() => {
        const backdrop = document.querySelector('.offcanvas-backdrop');
        if (backdrop) {
          backdrop.remove();
        }

        // Also remove Bootstrap body classes
        document.body.classList.remove('offcanvas-backdrop', 'modal-open');
        document.body.style.overflow = '';
      }, 300);
    };

    cleanupOffcanvas();
  }, [location]);

  return (
    <>
      <nav className="navbar fixed-top navbar-expand-lg custom-navbar">
        <div className="container-fluid d-flex align-items-center justify-content-between px-3">
          {/* Left - Call */}
          <a className="btn btn-outline-warning text-light d-none d-md-block" href="tel:+33661585885">
            <IoCall className="me-2" /> +33 6 15 85 88 5
          </a>

          {/* Center - Logo */}
          <Link className="navbar-brand mx-auto mx-md-0" to="/">
            <img className="logo" src="/assets/images/Revierradriverlogo.png" alt="Logo" loading="lazy" />
          </Link>

          {/* Right - Hamburger */}
          <button
            className="btn text-warning bg-dark fs-3 px-3 py-1"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
          >
            ☰
          </button>
        </div>
      </nav>

      {/* Offcanvas menu */}
      <div className="offcanvas offcanvas-end text-bg-dark" id="offcanvasNavbar" tabIndex="-1">
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <Link to="/" className="navbar-brand">
            <img className="logo" src="/assets/images/Revierradriverlogo.png" alt="Logo"loading="lazy" />
          </Link>
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav text-start">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/services">Services</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/bookingForm">Book Now</Link>
            </li>
            <li className="nav-item mt-3 d-md-none">
              <a className="btn btn-outline-warning w-100" href="tel:+33661585885">
                <IoCall className="me-2" /> Call Us
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
